module.exports = __webpack_public_path__ + "assets/404.cb2515ac.svg";